var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagSolid = function SvgFlagSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2a1 1 0 0 0-2 0v20a1 1 0 1 0 2 0v-6.462a3.32 3.32 0 0 1 .246-.11C5.741 15.232 6.613 15 8 15c1.28 0 2.36.421 3.629.928l.055.023C12.904 16.439 14.307 17 16 17c1.613 0 2.74-.27 3.496-.572.377-.15.658-.308.856-.44.098-.066.176-.125.235-.173.041-.034.081-.07.12-.107a.997.997 0 0 0 .293-.709V4a1 1 0 0 0-1.685-.729.96.96 0 0 1-.073.053c-.083.056-.24.148-.488.248C18.259 3.769 17.387 4 16 4c-1.28 0-2.36-.421-3.629-.928l-.055-.023C11.096 2.561 9.693 2 8 2c-1.292 0-2.272.173-3 .397V2Z",
    fill: "currentcolor"
  })));
};
export default SvgFlagSolid;